import {resetAllBanners} from 'src/containers/BannersConfig/slice';
import {rootApi} from 'src/models';

import {resetTenant} from './slice';

export const resetUser = () => (dispatch: TDispatch) => {
  dispatch(rootApi.util.resetApiState());
  dispatch(resetAllBanners());
  dispatch(resetTenant());
  sessionStorage.clear();
};
